/**
 * Where an autosaving settings page is in its save cycle.
 */
enum SaveState {
  Idle = 'idle',
  Saving = 'saving',
  Saved = 'saved',
  Error = 'error',
}

/**
 * One choice in a `RadioCardGroup`.
 */
interface RadioCardOption<TValue extends string> {
  value: TValue;
  label: string;
  description: string;
  /** ui-library `Icon` name shown before the label. */
  icon?: string;
  /** Short highlight shown after the label, e.g. "Recommended". */
  badge?: string;
}

export { SaveState };
export type { RadioCardOption };
